import {useSentryTracking as useBaseSentryTracking} from '../../nuxt-base/composables/useSentryTracking';

// Project-only tap into the existing API instrumentation. No Sentry SDK is
// loaded here; every response, exception and base tracking call is preserved.
export function useSentryTracking() {
	const base = useBaseSentryTracking();
	const logger = useNuxtApp().$diagnostics;
	return {
		...base,
		captureErrorPage(name, data) {
			try { logger?.page(name, data); } catch {}
			return base.captureErrorPage(name, data);
		},
		trackHapiRequest(tracking, runner) {
			if (!logger || !tracking) return base.trackHapiRequest(tracking, runner);
			const context = logger.context();
			// Correlate only same-origin Nuxt proxies; never add a header to HAPI/CORS calls.
			if (tracking.request?.url?.startsWith('/api/nuxtapi/') && tracking.request.headers) {
				try { tracking.request.headers['X-TZH-Diagnostic-Id'] = context.id; } catch {}
			}
			const started = Date.now();
			return base.trackHapiRequest(tracking, async controls => {
				let terminalError;
				try {
					const result = await runner({...controls, setTerminalError(error) { terminalError = error; controls.setTerminalError(error); }});
					try { logger.api(context, tracking, terminalError, result, Date.now() - started); } catch {}
					return result;
				} catch (error) {
					try { logger.api(context, tracking, terminalError || error, null, Date.now() - started); } catch {}
					throw error;
				}
			});
		},
	};
}
